import { css } from 'aphrodite';
import { rendererContainer, field, fieldReadOnly } from './styles/commonRendererStyles';
import type { AutomationStepNodeData } from '../../types/stepNodes';

interface NoActionStepRendererProps {
	nodeId: string;
	data: AutomationStepNodeData;
	readOnly?: boolean;
}

export function NoActionStepRenderer({
	nodeId: _nodeId,
	data: _data,
	readOnly: _readOnlyProp,
}: NoActionStepRendererProps) {
	return (
		<div className={css(rendererContainer)}>
			<div style={{ marginBottom: 4, fontSize: 14, color: '#4A4A4A' }}>Take no action.</div>
			<div
				className={css(field, fieldReadOnly)}
				style={{
					marginTop: 8,
					fontSize: 13,
					color: '#6B7280',
					fontStyle: 'italic',
				}}
			>
				This step does nothing and allows the automation to continue to the next step.
			</div>
		</div>
	);
}
